// extracted by mini-css-extract-plugin
export default {"amountCard":"AmountCard_amountCard__YWKIS","title":"AmountCard_title__KOKon","amount":"AmountCard_amount__trkxh"};